// ============================================
// gsap scrollTrigger
// ============================================
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function inview() {
  const inviewItems = gsap.utils.toArray('.js-inview');
  inviewItems.forEach((item) => {
    const delayTime = item.dataset.delay;
    if (delayTime) {
      item.style.transitionDelay = delayTime + 's';
    }

    ScrollTrigger.create({
      //markers: true,
      trigger: item, //アニメーションが始まるトリガーとなる要素
      start: 'top 75%',
      end: 'bottom 75%',
      toggleClass: {
        targets: item,
        className: 'is-active',
      },
      once: true,
    });
  });
}

function indexCommitment() {
  const wrap = document.querySelector('.p-index-commitment__container-large');
  if (!wrap) return;

  //進捗時応じてクラス名付与させる関数
  const targets = document.querySelectorAll('.p-index-commitment__contents');
  function scrollFadeAnim(index) {
    targets.forEach((target, i) => {
      if (i === index) {
        if (!target.classList.contains('is-active')) {
          target.classList.add('is-active');
        }
      } else {
        if (target.classList.contains('is-active')) {
          target.classList.remove('is-active');
        }
      }
    });
  }

  //スクロールアニメーション
  ScrollTrigger.create({
    trigger: wrap,
    start: () => 'center 50%',
    end: () => '+=500% bottom',
    pin: true,
    onUpdate: (self) => {
      const progress = self.progress;
      if (0 <= progress && progress < 0.2) {
        scrollFadeAnim(0);
      } else if (0.2 <= progress && progress < 0.4) {
        scrollFadeAnim(1);
      } else if (0.4 <= progress && progress < 0.6) {
        scrollFadeAnim(2);
      } else if (0.6 <= progress && progress < 0.8) {
        scrollFadeAnim(3);
      } else {
        scrollFadeAnim(4);
      }
    },
  });
}

// 追従メニュー スクロールでアクティブに
// ==========================
function changeNavActive() {
  const nav = document.querySelector('.c-sidenav__list');

  if (!nav) return;

  //flowページであればreturn;
  const flowPage = document.getElementById('flow');
  if (flowPage) return;

  const targets = nav.querySelectorAll('.c-sidenav__link');
  const targetArray = [];
  let num = 0;
  targets.forEach((target) => {
    const targetId = target.href.split('#')[1];
    targetArray[num] = document.getElementById(targetId);
    num++;
  });

  targetArray.forEach((target, index) => {
    ScrollTrigger.create({
      trigger: target,
      start: () => 'top 10%',
      onEnter: () => {
        addClass(targets[index]);
      },
      onLeaveBack: () => {
        addClass(targets[index - 1]);
      },
    });
  });

  //is-activeを全部外してtargetにつける関数
  function addClass(htmlDom) {
    if (!htmlDom) return;
    targets.forEach((target) => {
      if (target.classList.contains('is-active')) {
        target.classList.remove('is-active');
      }
    });
    htmlDom.classList.add('is-active');
  }
}

// 追従メニュー 背景ありの時には白色に
// ==========================
function navChangeColor() {
  const nav = document.querySelector('.c-sidenav');
  const targets = document.querySelectorAll('.js-hasBg');
  if (!nav || targets.length === 0) return;

  targets.forEach((target) => {
    ScrollTrigger.create({
      trigger: target,
      start: 'top 150',
      end: 'bottom 40%',
      onEnter: () => {
        if (!nav.classList.contains('is-white')) {
          nav.classList.add('is-white');
        }
      },
      onLeave: () => {
        if (nav.classList.contains('is-white')) {
          nav.classList.remove('is-white');
        }
      },
      onEnterBack: () => {
        if (!nav.classList.contains('is-white')) {
          nav.classList.add('is-white');
        }
      },
      onLeaveBack: () => {
        if (nav.classList.contains('is-white')) {
          nav.classList.remove('is-white');
        }
      },
    });
  });
}

// ============================================
// export
// ============================================
export { inview, indexCommitment, changeNavActive, navChangeColor };
